/*
  Szuflada koszyka. Caly stan liczy Liquid, skrypt tylko:
    - otwiera / zamyka panel i przelacza jego DWA KROKI (lista -> dostawa),
    - przechwytuje dodanie do koszyka, zeby zamiast przeladowania strony
      pokazac szuflade,
    - zmienia ilosci i usuwa pozycje (zestaw probek kaskadowo),
    - liczy koszt wysylki pod kod pocztowy i zapisuje uwagi do zamowienia,
    - po kazdej zmianie pobiera sekcje na nowo (Section Rendering API)
      i podmienia jej wnetrze.

  Krok 2 (Figma 1339:3175) nie ma wlasnego markupu: szuflada przenosi do
  swojego gniazda okno „Sprawdz dostawe" z sekcji `delivery-check` w layoucie.
  Dzieki temu w motywie jest JEDNO takie okno, a strona Kontakt dalej otwiera
  je po swojemu. Okno wraca na swoje miejsce przed kazda podmiana wnetrza
  szuflady i wchodzi z powrotem po niej - inaczej Section Rendering API
  skasowalby je razem z reszta HTML-a.

  Pytanie o adres NIE stoi juz przed dodaniem do koszyka (brama zdjeta
  21 wrzesnia 2026) - stoi przed kasa. Do kasy przechodzi sie z kroku 2,
  po tym jak klient zna werdykt dla swojego adresu.

  Klucz pozycji koszyka zmienia sie po kazdej zmianie przeliczajacej rabat,
  dlatego kilka pozycji naraz (kaskada zestawu) idzie JEDNYM /cart/update.js,
  a nie seria /cart/change.js na zapamietanych kluczach.
*/
(() => {
  const SEKCJA = 'cart-drawer';

  const json = async (url, opcje) => {
    const odpowiedz = await fetch(url, {
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...opcje,
    });
    if (!odpowiedz.ok) throw new Error(`${url} -> ${odpowiedz.status}`);
    return odpowiedz.json();
  };

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.gotowy) return;
      this.gotowy = true;
      this.zablokowane = false;
      /* Krok 1 to lista, krok 2 to dostawa i odbior. Stan trzyma element, a nie
         Liquid - przezywa wiec kazde przerysowanie sekcji. `werdykt` to
         odpowiedz okna dostawy: null = klient jeszcze nie pytal. */
      this.krok = 1;
      this.werdykt = null;
      this.czekaNaOdbior = false;
      /* Czy klient stoi teraz w kalendarzu odbioru - wtedy dolny przycisk
         rezerwuje termin i dopiero potem przenosi do kasy. */
      this.wKalendarzu = false;
      this.podepnij();
      this.podepnijPrzeciaganieUchwytu();
      this.podepnijGlobalne();
    }

    /* ---------- wiazanie zdarzen wewnatrz panelu ---------- */

    podepnij() {
      /* Zamkniecie po kliknieciu w tlo liczy sie od NACISNIECIA, nie od
         pusczenia: gdy z listy znika ostatnia pozycja, panel robi sie nizszy
         i palec laduje juz nad tlem - przegladarka wysyla wtedy klikniecie
         w tlo i szuflada zamykala sie sama zaraz po "Usun". */
      this.addEventListener('pointerdown', (zdarzenie) => {
        this.naciskTlo = Boolean(zdarzenie.target.closest('.cart-drawer__overlay'));
      });

      this.addEventListener('click', (zdarzenie) => {
        const zamknij = zdarzenie.target.closest('[data-cart-drawer-close]');
        if (zamknij) {
          const tlo = zamknij.classList.contains('cart-drawer__overlay');
          if (tlo && this.naciskTlo === false) return;
          zdarzenie.preventDefault();
          this.zamknij();
          return;
        }

        const dalej = zdarzenie.target.closest('[data-cart-next]');
        if (dalej) {
          zdarzenie.preventDefault();
          /* Same probki: paczka z profilu 0 €, bez pytania o zasieg busa (AUD-01). */
          if (dalej.hasAttribute('data-cart-parcel-only')) this.doKasy();
          else this.idzDoKroku(2);
          return;
        }

        /* W kalendarzu dolny przycisk nie idzie do kasy, tylko wysyla
           rezerwacje - do kasy przenosi dopiero jej potwierdzenie. */
        if (this.wKalendarzu && zdarzenie.target.closest('[data-cart-checkout-button]')) {
          zdarzenie.preventDefault();
          const picker = this.querySelector('[data-booking-picker]');
          const wyslij = picker ? picker.querySelector('[data-booking-submit]') : null;
          if (!wyslij) return;
          this.poRezerwacjiDoKasy = true;
          wyslij.click();
          return;
        }

        if (zdarzenie.target.closest('[data-cart-booking-clear]')) {
          zdarzenie.preventDefault();
          this.zapomnijRezerwacje();
          return;
        }

        if (zdarzenie.target.closest('[data-cart-back]')) {
          zdarzenie.preventDefault();
          this.idzDoKroku(1);
          return;
        }

        /* Kalkulator wysylki pyta o to samo co krok 2, wiec jego przycisk
           prowadzi tam, zamiast otwierac osobne okno. */
        if (zdarzenie.target.closest('[data-delivery-check-open]')) {
          zdarzenie.preventDefault();
          this.idzDoKroku(2);
          return;
        }

        const krok = zdarzenie.target.closest('[data-cart-drawer-step]');
        if (krok) {
          zdarzenie.preventDefault();
          this.wyczyscKod();
          this.przesunIlosc(krok);
          return;
        }

        const ilosc = zdarzenie.target.closest('[data-cart-drawer-quantity]');
        if (ilosc) {
          zdarzenie.preventDefault();
          this.zmienIlosc(ilosc);
          return;
        }

        const plusWzoru = zdarzenie.target.closest('[data-cart-set-plus]');
        if (plusWzoru) {
          zdarzenie.preventDefault();
          this.dodajOkienko(plusWzoru);
          return;
        }

        const minusWzoru = zdarzenie.target.closest('[data-cart-set-minus]');
        if (minusWzoru) {
          zdarzenie.preventDefault();
          this.zdejmijOkienko(minusWzoru);
          return;
        }

        const usunZestaw = zdarzenie.target.closest('[data-cart-drawer-remove-set]');
        if (usunZestaw) {
          zdarzenie.preventDefault();
          this.usunZestaw(usunZestaw.closest('[data-cart-set]'));
          return;
        }

        const harmonijkaWysylki = zdarzenie.target.closest('.cart-drawer-calc__summary');
        if (harmonijkaWysylki) {
          this.przelacz(harmonijkaWysylki, 'cart-drawer-calc', 'cart-drawer-calc--open');
          return;
        }

        const harmonijkaKodu = zdarzenie.target.closest('.cart-drawer-discount__summary');
        if (harmonijkaKodu) {
          this.przelacz(harmonijkaKodu, 'cart-drawer-discount', 'cart-drawer-discount--open');
          const pole = this.querySelector('[data-cart-drawer-discount-field]');
          if (pole && harmonijkaKodu.getAttribute('aria-expanded') === 'true') {
            window.setTimeout(() => pole.focus({ preventScroll: true }), 240);
          }
          return;
        }

        const usunKod = zdarzenie.target.closest('[data-cart-drawer-discount-remove]');
        if (usunKod) {
          this.zmienKody({ usun: usunKod.dataset.cartDrawerDiscountRemove });
          return;
        }

        const harmonijkaUwag = zdarzenie.target.closest('.cart-drawer-note__summary');
        if (harmonijkaUwag) {
          const bylOtwarty = Boolean(this.querySelector('.cart-drawer-note--open'));
          this.przelacz(harmonijkaUwag, 'cart-drawer-note', 'cart-drawer-note--open');
          if (bylOtwarty) this.zapiszUwagi();
          else this.pokazPoleUwag();
          return;
        }

        if (zdarzenie.target.closest('[data-cart-drawer-zip-submit]')) {
          zdarzenie.preventDefault();
          this.policzWysylke();
          return;
        }

        if (zdarzenie.target.closest('[data-cart-drawer-zip-clear]')) {
          zdarzenie.preventDefault();
          this.wyczyscKod();
          return;
        }

      });

      /* Kod rabatowy: formularz jest podmieniany razem z cala sekcja, wiec
         wysylke lapiemy na samym elemencie szuflady, nie na formularzu. */
      this.addEventListener('submit', (zdarzenie) => {
        if (!zdarzenie.target.closest('[data-cart-drawer-discount-form]')) return;
        zdarzenie.preventDefault();
        const pole = this.querySelector('[data-cart-drawer-discount-field]');
        const kod = pole ? pole.value.trim() : '';
        if (kod) this.zmienKody({ dodaj: kod });
      });

      /* Do kasy z krajem i kodem sprawdzonym w kroku 2: kasa wpisuje je w adres
         i od razu pokazuje stawke. POST na /cart tych pol nie przenosi (zmierzone
         27 pazdziernika 2026), adres w zapytaniu /checkout - tak. Wybrany odbior
         osobisty idzie zwyklym POST-em, bez adresu. */
      this.addEventListener('submit', (zdarzenie) => {
        if (!zdarzenie.target.closest('[data-cart-checkout]')) return;
        /* Ilosc wciaz w drodze do sklepu - kasa poczeka na nia (doKasy wysle
           formularz jeszcze raz, juz bez czekajacych zmian). */
        if (this.doWyslania || this.wysylkaIlosci) {
          zdarzenie.preventDefault();
          this.doKasy();
          return;
        }
        const adres = this.adresKasy;
        if (!adres || !adres.kraj || !adres.kod || this.wybranyOdbior || zdarzenie.defaultPrevented) return;
        zdarzenie.preventDefault();
        const korzen = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const zapytanie = new URLSearchParams({
          'checkout[shipping_address][country]': adres.kraj,
          'checkout[shipping_address][zip]': adres.kod,
        });
        window.location.href = `${korzen}checkout?${zapytanie}`;
      });

      /* Uwagi zapisuja sie SAME: chwile po tym, jak klient przestanie pisac.
         Bez przyciskow "Zapisz" i "Anuluj" - nie da sie zapomniec zapisac,
         a pole i tak pokazuje ostatnia zapisana tresc po odswiezeniu. */
      this.addEventListener('input', (zdarzenie) => {
        if (!zdarzenie.target.closest('[data-cart-drawer-note-field]')) return;
        window.clearTimeout(this.zegarUwag);
        this.zegarUwag = window.setTimeout(() => this.zapiszUwagi(), 800);
      });

      /* Listy wyboru przy wzorach zestawu - zmiana idzie do sklepu z opoznieniem. */
      this.addEventListener('change', (zdarzenie) => {
        const pole = zdarzenie.target.closest('[data-cart-set-sample], [data-cart-set-add]');
        if (pole) this.zaplanujZestaw(pole);
      });

      /* Klient przechodzi do kolejnej listy, zeby zmienic nastepny wzor -
         na ten czas zapis czeka (inaczej szuflada przerysowalaby sie pod
         otwarta lista), a odliczanie rusza od nowa, gdy z listy wyjdzie. */
      this.addEventListener('focusin', (zdarzenie) => {
        if (!zdarzenie.target.closest('[data-cart-set-sample], [data-cart-set-add]')) return;
        window.clearTimeout(this.zegarZestawu);
      });
      this.addEventListener('focusout', (zdarzenie) => {
        if (!zdarzenie.target.closest('[data-cart-set-sample], [data-cart-set-add]')) return;
        if (this.zestawyDoWyslania && this.zestawyDoWyslania.size) this.odliczZestaw();
      });

      this.addEventListener('input', (zdarzenie) => {
        const pole = zdarzenie.target.closest('[data-cart-drawer-zip]');
        if (!pole) return;
        const krzyzyk = this.querySelector('[data-cart-drawer-zip-clear]');
        if (krzyzyk) krzyzyk.hidden = pole.value.trim() === '';
      });

      /* Werdykt oglasza samo okno dostawy, ktore w kroku 2 jest dzieckiem
         szuflady - zdarzenie babelkuje, wiec wystarczy jeden nasluch. */
      this.addEventListener('dostawa:werdykt', (zdarzenie) => {
        const opis = zdarzenie.detail || {};
        this.werdykt = Boolean(opis.dowozimy);
        this.adresKasy = opis.adres || null;
        /* Gdy nie dowozimy, a magazyny przyjmuja rezerwacje, sam werdykt nie
           otwiera kasy: zamowienie bez wybranego odbioru nie mialoby jak
           dojechac do klienta. Gdy rezerwacji nie ma, werdykt wystarcza -
           to informacja, nie blokada. */
        this.czekaNaOdbior = Boolean(opis.wymagaOdbioru);
        this.zastosujKrok();
      });

      /* Wybrany magazyn (bez kalendarza rezerwacji) tez jest odpowiedzia na
         pytanie o dostawe - klient odbierze sam, wiec kod pocztowy nie jest
         mu potrzebny, a kasa otwiera sie od razu. */
      this.addEventListener('dostawa:odbior-stan', (zdarzenie) => {
        this.brakOdbioru = Boolean(zdarzenie.detail && zdarzenie.detail.brak);
        this.zastosujKrok();
      });

      this.addEventListener('dostawa:wybor-odbioru', (zdarzenie) => {
        this.wybranyOdbior = Boolean(zdarzenie.detail && zdarzenie.detail.magazyn);
        this.zastosujKrok();
      });

      /* Wejscie w kalendarz i powrot z niego zmieniaja WYSOKOSC kroku 2, a nie
         krok - przewijanie zostawalo wiec tam, gdzie stala lista magazynow,
         i gora kalendarza chowala sie pod naglowkiem szuflady. */
      this.addEventListener('click', (zdarzenie) => {
        if (!zdarzenie.target.closest('[data-booking-start]')) return;
        this.wKalendarzu = true;
        this.zastosujKrok();
        this.pilnujPrzyciskuRezerwacji();
        requestAnimationFrame(() => this.naGoreTresci());
      });

      this.addEventListener('booking:back', () => {
        this.wKalendarzu = false;
        this.przestanPilnowac();
        this.zastosujKrok();
        requestAnimationFrame(() => this.naGoreTresci());
      });

      /* Termin zapisany: rezerwacja JEST odpowiedzia na pytanie o dostawe,
         wiec kasa staje otworem takze wtedy, gdy klient nie podal kodu
         pocztowego - odbiera osobiscie, dowoz go nie dotyczy. */
      this.addEventListener('dostawa:odbior', () => {
        this.czekaNaOdbior = false;
        this.wKalendarzu = false;
        this.przestanPilnowac();
        if (this.werdykt === null) this.werdykt = false;
        this.zastosujKrok();
        if (this.poRezerwacjiDoKasy) {
          this.poRezerwacjiDoKasy = false;
          this.doKasy();
          return;
        }
        /* Klient zostaje w szufladzie - przerysowujemy krok 2, zeby zamiast
           pytania stalo potwierdzenie z atrybutow koszyka. */
        this.odswiez();
      });

      this.addEventListener('keydown', (zdarzenie) => {
        if (zdarzenie.key !== 'Enter') return;
        if (!zdarzenie.target.closest('[data-cart-drawer-zip]')) return;
        zdarzenie.preventDefault();
        this.policzWysylke();
      });
    }

    /* ---------- wiazanie zdarzen poza panelem ---------- */

    podepnijGlobalne() {
      /* Koszyk tego sklepu to SZUFLADA - strona /cart jest tylko zapasem dla
         przegladarki bez skryptow. Dlatego przechwytujemy KAZDY odnosnik
         prowadzacy na strone koszyka (ikona w naglowku, pasek potwierdzenia
         listy zyczen, stopka), a nie tylko ikone. Odnosnik zostaje
         odnosnikiem, wiec bez skryptu wszystko dziala jak dotad; odnosnik
         z [data-cart-page] celowo idzie na strone. */
      const doKoszyka = (element) => {
        if (!(element instanceof HTMLAnchorElement)) return false;
        if (element.hasAttribute('data-cart-page')) return false;
        if (element.target && element.target !== '_self') return false;
        try {
          const adres = new URL(element.href, window.location.origin);
          if (adres.origin !== window.location.origin) return false;
          return /\/cart\/?$/.test(adres.pathname) && adres.search === '';
        } catch (e) {
          return false;
        }
      };

      document.addEventListener('click', (zdarzenie) => {
        const cel = zdarzenie.target.closest('.site-header__cart, [data-cart-drawer-open], a[href]');
        if (!cel) return;
        const pasuje = cel.matches('.site-header__cart, [data-cart-drawer-open]') || doKoszyka(cel);
        if (!pasuje) return;
        if (zdarzenie.metaKey || zdarzenie.ctrlKey || zdarzenie.shiftKey) return;
        zdarzenie.preventDefault();
        this.otworz();
      });

      document.addEventListener('keydown', (zdarzenie) => {
        if (zdarzenie.key === 'Escape' && !this.hidden) this.zamknij();
      });

      /* Edytor motywu przerysowuje sekcje dostawy w jej wlasnym miejscu, wiec
         okno trzymane w kroku 2 zostaloby osieroconym duplikatem. */
      document.addEventListener('shopify:section:load', (zdarzenie) => {
        if (!zdarzenie.target.querySelector('delivery-check')) return;
        const moje = this.querySelector('delivery-check');
        if (moje) moje.remove();
        if (this.krok === 2) this.wpiszDostawe();
      });

      /* Wejscie dla innych czesci motywu (konfigurator zestawu, lista zyczen),
         zeby nikt nie musial przenosic klienta na strone koszyka. */
      window.dizzKoszyk = {
        otworz: async ({ odswiez = false } = {}) => {
          if (odswiez) await this.odswiez();
          this.otworz();
        },
        /* Przerysowanie bez otwierania - np. po zdjeciu kodu firmowego. */
        odswiez: () => this.odswiez(),
      };

      /* Dodanie do koszyka z dowolnego formularza produktu: zamiast
         przeladowania strony pokazujemy szuflade ze swiezym koszykiem. */
      document.addEventListener('submit', async (zdarzenie) => {
        const formularz = zdarzenie.target;
        if (!(formularz instanceof HTMLFormElement)) return;
        const adres = formularz.getAttribute('action') || '';
        if (!adres.includes('/cart/add')) return;
        /* Konfigurator zestawu sklada koszyk sam (nosnik + probki) - jego
           formularza nie dotykamy, inaczej nosnik wpadlby drugi raz. */
        if (formularz.closest('[data-sample-set]')) return;

        zdarzenie.preventDefault();
        const przycisk = formularz.querySelector('[type="submit"]');
        const dane = new FormData(formularz);

        const dodaj = async () => {
          if (przycisk) przycisk.disabled = true;
          try {
            await fetch('/cart/add.js', { method: 'POST', body: dane });
            await this.odswiez();
            this.otworz();
          } catch (blad) {
            formularz.submit();
          } finally {
            if (przycisk) przycisk.disabled = false;
          }
        };

        /* Nic nie staje przed dodaniem do koszyka: o obszar dowozu pytamy
           dopiero w kroku 2, na drodze do kasy. Nie przywracaj tu bramy -
           kosztowala klikniecie przy KAZDYM pierwszym produkcie w wizycie. */
        dodaj();
      });
    }

    /* ---------- otwieranie i zamykanie ---------- */

    /* Nosnik zestawu bez swoich probek nic nie znaczy, a w kasie klient by za
       niego zaplacil. Takie pozycje Liquid oznacza [data-cart-orphan] - tu
       znikaja przy pierwszym otwarciu szuflady. Strażnik pilnuje, zeby
       sprzatanie nie zapetlilo sie z odswiezaniem. */
    async posprzataj() {
      const osierocone = [...this.querySelectorAll('[data-cart-orphan]')];
      if (osierocone.length === 0 || this.sprzatam) return;
      this.sprzatam = true;
      const zmiany = {};
      osierocone.forEach((wiersz) => { zmiany[wiersz.dataset.cartOrphan] = 0; });
      try {
        await json('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: zmiany }) });
        await this.odswiez();
      } catch (blad) { /* zostaje widoczna pozycja, klient usunie ja sam */ }
      this.sprzatam = false;
    }

    /* Dociecie plyt zapisuje sie w koszyku w jezyku, w ktorym klient dodal
       plyte (nazwa i tresc wlasciwosci to zwykly tekst). Po zmianie jezyka
       Liquid oznacza takie pozycje [data-cart-cutting] z nazwa i trescia
       w biezacym jezyku, a tu przepisujemy je w koszyku - wtedy takze kasa
       i zamowienie mowia jezykiem klienta. Ukryte _dociecie trzyma nazwe,
       pod ktora wlasciwosc lezy teraz. Po kazdej zmianie klucze pozycji
       sie zmieniaja, wiec koszyk czytamy od nowa przed kazda zmiana. */
    async przetlumaczDociecie() {
      const wiersz = this.querySelector('[data-cart-cutting]');
      if (!wiersz || this.tlumacze) return;
      this.tlumacze = true;
      const nazwa = wiersz.dataset.cartCutting;
      const tresc = wiersz.dataset.cartCuttingValue;
      try {
        for (let proba = 0; proba < 10; proba += 1) {
          const koszyk = await json('/cart.js');
          const indeks = koszyk.items.findIndex((p) => p.properties && p.properties._dociecie && p.properties._dociecie !== nazwa);
          if (indeks === -1) break;
          const pozycja = koszyk.items[indeks];
          const wlasciwosci = {};
          Object.keys(pozycja.properties).forEach((k) => {
            if (k !== pozycja.properties._dociecie) wlasciwosci[k] = pozycja.properties[k];
          });
          wlasciwosci[nazwa] = tresc;
          wlasciwosci._dociecie = nazwa;
          await json('/cart/change.js', {
            method: 'POST',
            body: JSON.stringify({ id: pozycja.key, quantity: pozycja.quantity, properties: wlasciwosci }),
          });
        }
        await this.odswiez();
      } catch (blad) { /* zostaje stara nazwa - informacja ta sama, inny jezyk */ }
      this.tlumacze = false;
    }

    /* Wpisy „Probka nr N" na nosniku zestawu tez zapisuja sie w jezyku
       dodania - klient, ktory zlozyl zestaw po niemiecku i przeszedl na
       niderlandzki, widzial w kasie „Muster Nr. 1" (zgloszenie 27.10.2026).
       Etykieta biezacego jezyka stoi na karcie zestawu (data-slot-label);
       wpis w innym zapisie przepisujemy, zachowujac kolejnosc i nazwy
       wzorow. Klucz pozycji zmienia sie po kazdej zmianie, wiec koszyk
       czytamy od nowa przed kazda zmiana. */
    async przetlumaczZestawy() {
      const karta = this.querySelector('[data-cart-set][data-slot-label]');
      if (!karta || this.tlumaczeZestawy) return;
      /* Shopify obcina dwukropek z konca nazwy wlasciwosci - porownujemy bez niego. */
      const etykieta = karta.dataset.slotLabel.replace(/:\s*$/, '');
      const ucieczka = etykieta.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace('__N__', '\\d+');
      const wzorzec = new RegExp('^' + ucieczka + ':?$');
      this.tlumaczeZestawy = true;
      let zmienione = false;
      try {
        for (let proba = 0; proba < 10; proba += 1) {
          const koszyk = await json('/cart.js');
          const pozycja = koszyk.items.find((p) => p.properties && p.properties._zestaw_rola === 'nosnik'
            && Object.keys(p.properties).some((k) => k.charAt(0) !== '_' && p.properties[k] && !wzorzec.test(k)));
          if (!pozycja) break;
          const wlasciwosci = {};
          let n = 0;
          Object.keys(pozycja.properties).forEach((k) => {
            if (k.charAt(0) === '_') wlasciwosci[k] = pozycja.properties[k];
            else if (pozycja.properties[k]) { n += 1; wlasciwosci[etykieta.replace('__N__', String(n))] = pozycja.properties[k]; }
          });
          await json('/cart/change.js', {
            method: 'POST',
            body: JSON.stringify({ id: pozycja.key, quantity: pozycja.quantity, properties: wlasciwosci }),
          });
          zmienione = true;
        }
        if (zmienione) await this.odswiez();
      } catch (blad) { /* zostaje stara etykieta - te same wzory, inny jezyk */ }
      this.tlumaczeZestawy = false;
    }

    otworz() {
      this.posprzataj();
      /* Po kolei, nie naraz: kazda zmiana pozycji zmienia klucze w koszyku,
         wiec rownolegle przepisanie zestawu uniewaznialo klucz dociecia
         i jego tlumaczenie po cichu odpadalo (kasa DE z „Platen op maat
         zagen”, 27.10.2026). */
      this.przetlumaczDociecie().then(() => this.przetlumaczZestawy());
      /* Szuflada otwiera sie zawsze na liscie - krok 2 jest miejscem, do
         ktorego klient sam przechodzi, a nie stanem, w ktorym go zastajemy. */
      if (this.krok !== 1) this.idzDoKroku(1);
      else this.zastosujKrok();
      this.hidden = false;
      /* Podwojna klatka: przegladarka musi zdazyc policzyc stan zamkniety,
         inaczej panel pojawi sie bez animacji wysuwania. */
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('cart-drawer--open')));
      this.zablokujPrzewijanie();
      const panel = this.querySelector('.cart-drawer__panel');
      if (panel) panel.focus();
    }

    zamknij() {
      this.classList.remove('cart-drawer--open');
      /* Okno dostawy wraca na swoje miejsce w layoucie - ze szuflady wypozycza
         je tylko na czas kroku 2, a strona Kontakt otwiera je stamtad. */
      if (this.krok === 2) this.idzDoKroku(1);
      this.odblokujPrzewijanie();
      const koniec = () => {
        this.hidden = true;
      };
      const panel = this.querySelector('.cart-drawer__panel');
      if (!panel) return koniec();
      panel.addEventListener('transitionend', koniec, { once: true });
      setTimeout(koniec, 400);
    }

    zablokujPrzewijanie() {
      if (this.zablokowane) return;
      this.zablokowane = true;
      window.dizzBlokadaTla?.zablokuj(this.querySelector('.cart-drawer__panel') || this);
    }

    odblokujPrzewijanie() {
      if (!this.zablokowane) return;
      this.zablokowane = false;
      window.dizzBlokadaTla?.odblokuj();
    }

    /* ---------- kroki ---------- */

    idzDoKroku(numer) {
      const krok = numer === 2 ? 2 : 1;
      if (krok === 2) {
        /* Bez okna dostawy (sekcja wylaczona pustym naglowkiem) drugiego kroku
           po prostu nie ma - szuflada zostaje jednokrokowa z kasa pod lista. */
        if (!this.wpiszDostawe()) return;
      } else if (window.dizzDostawa && window.dizzDostawa.zKoszyka) {
        window.dizzDostawa.zKoszyka();
      }
      this.krok = krok;
      this.zastosujKrok();
      this.naGoreTresci();
      if (krok === 2) this.sprawdzUmowiony();
    }

    /* Umowiony odbior przezywa zmiany koszyka (siedzi w atrybutach), a kasa
       wypuszcza odbior tylko z magazynu, ktory ma CALY koszyk. Gdy klient
       dolozyl po rezerwacji wzor, ktorego tam nie ma, potwierdzenie mowi to
       wprost i kasa czeka na zmiane terminu - inaczej odbior znikal dopiero
       w kasie, bez slowa wyjasnienia. */
    async sprawdzUmowiony() {
      const numer = (this.numerUmowionego = (this.numerUmowionego || 0) + 1);
      this.odbiorBezTowaru = false;
      const blok = this.querySelector('[data-cart-booked]');
      const pytanie = window.dizzDostawa && window.dizzDostawa.magazynyZKoszykiem;
      if (!blok || !blok.dataset.bookedCity || !pytanie || this.krok !== 2) return;
      const czyMa = await pytanie();
      if (numer !== this.numerUmowionego || !czyMa || !blok.isConnected) return;
      const brak = !czyMa(blok.dataset.bookedCity);
      this.odbiorBezTowaru = brak;
      blok.classList.toggle('cart-drawer-booked--brak', brak);
      const ostrzezenie = blok.querySelector('[data-booked-stock]');
      if (ostrzezenie) ostrzezenie.hidden = !brak;
      this.zastosujKrok();
    }

    /* „Zmien termin odbioru" - kasujemy atrybuty koszyka i wracamy do pytania.
       Sama rezerwacja po stronie magazynu wygasa sama, gdy nie zwiaze sie
       z zamowieniem; tutaj chodzi o to, zeby klient nie umowil tego samego
       koszyka drugi raz na kolejna wizyte. */
    async zapomnijRezerwacje() {
      const puste = {
        rezerwacja_id__: '',
        'Kod rezerwacji': '',
        'Odbiór - magazyn': '',
        'Odbiór - termin': '',
      };
      this.zablokuj(true);
      try {
        await json('/cart/update.js', { method: 'POST', body: JSON.stringify({ attributes: puste }) });
        this.werdykt = null;
        this.adresKasy = null;
        this.czekaNaOdbior = false;
        this.wybranyOdbior = false;
        await this.odswiez();
      } catch (blad) {
        this.pokazBlad();
      } finally {
        this.zablokuj(false);
      }
    }

    /* Przycisk kalendarza jest schowany, ale to on wie, czy termin zostal juz
       wybrany - przepisujemy jego stan na dolny przycisk szuflady, zeby nie
       wygladal na czynny, kiedy klikniecie i tak nic nie zrobi. */
    pilnujPrzyciskuRezerwacji() {
      this.przestanPilnowac();
      const zrodlo = this.querySelector('[data-booking-submit]');
      if (!zrodlo) return;
      const przepisz = () => {
        const cel = this.querySelector('[data-cart-checkout-button]');
        if (!cel || !this.wKalendarzu) return;
        cel.disabled = zrodlo.disabled;
        /* Wylaczony przycisk ma mowic, CZEGO brakuje, a nie tylko byc szary. */
        const napis = zrodlo.disabled ? cel.dataset.labelPickDay : cel.dataset.labelReserve;
        if (napis) cel.textContent = napis;
        const brama = this.querySelector('[data-cart-gate]');
        if (brama) brama.hidden = true;
      };
      this.straznikRezerwacji = new MutationObserver(przepisz);
      this.straznikRezerwacji.observe(zrodlo, { attributes: true, attributeFilter: ['disabled'] });
      przepisz();
    }

    przestanPilnowac() {
      if (!this.straznikRezerwacji) return;
      this.straznikRezerwacji.disconnect();
      this.straznikRezerwacji = null;
    }

    /* Wysylka formularza kasy DOKLADNIE tak, jak gdyby klient kliknal przycisk:
       z przyciskiem jako nadawca. Bez tego pole `name="checkout"` nie wchodzi
       do zadania, Shopify dostaje goly POST na /cart i zamiast kasy pokazuje
       strone koszyka (zmierzone 22 wrzesnia 2026).
       Zmiana ilosci kliknieta tuz przed przyciskiem idzie do sklepu najpierw -
       formularz kasy nie niesie ilosci, kasa bierze je z koszyka. */
    async doKasy() {
      if (this.doWyslania || this.wysylkaIlosci) {
        window.clearTimeout(this.zegarIlosci);
        await this.wyslijIlosci();
      }
      const formularz = this.querySelector('[data-cart-checkout]');
      if (!formularz) return;
      const przycisk = formularz.querySelector('[data-cart-checkout-button]');
      if (przycisk && typeof formularz.requestSubmit === 'function') {
        przycisk.disabled = false;
        formularz.requestSubmit(przycisk);
        return;
      }
      /* Zapas: dokladamy pole recznie, zeby zadanie bylo takie samo. */
      const pole = document.createElement('input');
      pole.type = 'hidden';
      pole.name = 'checkout';
      pole.value = '';
      formularz.appendChild(pole);
      formularz.submit();
    }

    naGoreTresci() {
      const tresc = this.querySelector('[data-cart-drawer-body]');
      if (tresc) tresc.scrollTop = 0;
    }

    /* Przeniesienie okna dostawy do gniazda kroku 2. Oddaje false, gdy okna
       w motywie nie ma - wtedy nie udajemy, ze krok istnieje. */
    wpiszDostawe() {
      const gniazdo = this.querySelector('[data-cart-delivery-slot]');
      if (!gniazdo || !window.dizzDostawa || !window.dizzDostawa.wKoszyku) return false;
      window.dizzDostawa.wKoszyku(gniazdo);
      return Boolean(gniazdo.querySelector('delivery-check'));
    }

    /* Jedno miejsce, ktore uklada szuflade pod aktualny krok: sceny, przyciski
       stopki i pasek postepu. Wolamy je takze po kazdym przerysowaniu sekcji,
       bo Liquid renderuje zawsze krok 1. */
    zastosujKrok() {
      const krok = this.krok === 2 ? 2 : 1;
      /* Umowiony odbior jest ODPOWIEDZIA sam w sobie i przezywa odswiezenie
         strony (siedzi w atrybutach koszyka), wiec kase otwiera takze wtedy,
         gdy klient wrocil na sklep po przerwie. */
      const umowione = Boolean(this.querySelector('[data-cart-booked]')) && !this.odbiorBezTowaru;
      const zna = umowione || this.wybranyOdbior || (this.werdykt !== null && !this.czekaNaOdbior);
      this.classList.toggle('cart-drawer--krok-2', krok === 2);

      const scena1 = this.querySelector('[data-cart-stage="1"]');
      const scena2 = this.querySelector('[data-cart-stage="2"]');
      if (scena1) scena1.hidden = krok === 2;
      if (scena2) scena2.hidden = krok !== 2;

      const dalej = this.querySelector('[data-cart-next]');
      const kasa = this.querySelector('[data-cart-checkout]');
      const wstecz = this.querySelector('[data-cart-back]');
      const brama = this.querySelector('[data-cart-gate]');
      if (dalej) dalej.hidden = krok === 2;
      if (kasa) kasa.hidden = krok !== 2;
      if (wstecz) wstecz.hidden = krok !== 2;
      if (brama) {
        /* Przy umowionym magazynie bez towaru mowi samo potwierdzenie. */
        brama.hidden = krok !== 2 || this.wKalendarzu || zna || this.odbiorBezTowaru || Boolean(this.czekaNaOdbior && this.brakOdbioru);
        const klucz = this.czekaNaOdbior ? 'pickupGate' : 'zoneGate';
        if (!brama.hidden) brama.textContent = brama.dataset[klucz] || brama.textContent;
      }

      /* Do kasy wchodzi sie z werdyktem w reku - takze z odpowiedzia „nie
         dowozimy", bo to informacja, nie blokada: pod nia stoja magazyny
         do odbioru osobistego. */
      const przyciskKasy = kasa ? kasa.querySelector('[data-cart-checkout-button]') : null;
      if (przyciskKasy && krok === 2) {
        const wKalendarzu = Boolean(this.wKalendarzu);
        const rezerwacja = wKalendarzu ? this.querySelector('[data-booking-submit]') : null;
        const brakTerminu = Boolean(rezerwacja && rezerwacja.disabled);
        przyciskKasy.disabled = wKalendarzu ? brakTerminu : !zna;
        let napis = przyciskKasy.dataset.labelCheckout;
        if (wKalendarzu) {
          napis = brakTerminu
            ? przyciskKasy.dataset.labelPickDay
            : przyciskKasy.dataset.labelReserve;
        }
        if (napis) przyciskKasy.textContent = napis;
      }
      const podpowiedzOdbioru = this.querySelector('[data-cart-pickup-hint]');
      if (podpowiedzOdbioru) podpowiedzOdbioru.hidden = krok !== 2 || !(this.wKalendarzu || umowione);
      this.classList.toggle('cart-drawer--kalendarz', Boolean(this.wKalendarzu));

      const kroki = this.querySelector('[data-cart-steps]');
      if (!kroki) return;
      /* `dataset` nie czyta `data-step-label-2` pod nazwa `stepLabel2` -
         czlon po myslniku zaczyna sie od cyfry, wiec siegamy po atrybut. */
      const etykieta = kroki.getAttribute(`data-step-label-${krok}`) || '';
      const napis = kroki.querySelector('[data-cart-steps-label]');
      const tor = kroki.querySelector('[data-cart-steps-track]');
      if (napis) napis.textContent = etykieta;
      if (tor) tor.setAttribute('aria-label', etykieta);
      kroki.querySelectorAll('[data-cart-step-marker]').forEach((znacznik) => {
        const numer = Number(znacznik.dataset.cartStepMarker);
        znacznik.classList.toggle('cart-drawer__step--done', numer <= krok);
      });
    }

    /* ---------- harmonijki ---------- */

    przelacz(przycisk, klasaBloku, klasaOtwarcia) {
      const blok = przycisk.closest(`.${klasaBloku}`);
      if (!blok) return;
      const otwarte = blok.classList.toggle(klasaOtwarcia);
      przycisk.setAttribute('aria-expanded', String(otwarte));

      // Harmonijka siedzi na dole przewijanej tresci, wiec po rozwinieciu jej
      // wnetrze laduje pod podsumowaniem i klient go nie widzi. Po zakonczeniu
      // animacji przewijamy liste tak, zeby caly blok byl na ekranie.
      if (!otwarte) return;
      const tresc = this.querySelector('.cart-drawer__body');
      if (!tresc) return;
      window.setTimeout(() => {
        const brakuje = blok.getBoundingClientRect().bottom - tresc.getBoundingClientRect().bottom;
        if (brakuje > 0) tresc.scrollBy({ top: brakuje + 12, behavior: 'smooth' });
      }, 280);
    }

    /* Uwagi sa na samym DOLE przewijanej tresci, wiec po rozwinieciu pole
       potrafi zostac poza ekranem - a na telefonie dodatkowo zaslania je
       klawiatura, ktora wchodzi dopiero po chwili i zmienia widoczny obszar.
       Dlatego przewijamy dwa razy: po animacji rozwijania i po wejsciu
       klawiatury. */
    pokazPoleUwag() {
      const pole = this.querySelector('[data-cart-drawer-note-field]');
      if (!pole) return;
      const przewin = () => pole.scrollIntoView({ block: 'center', behavior: 'smooth' });
      window.setTimeout(() => {
        pole.focus({ preventScroll: true });
        przewin();
      }, 240);
      window.setTimeout(przewin, 700);
    }

    zamknijUwagi() {
      const blok = this.querySelector('[data-cart-drawer-note]');
      if (!blok) return;
      blok.classList.remove('cart-drawer-note--open');
      const przycisk = blok.querySelector('.cart-drawer-note__summary');
      if (przycisk) przycisk.setAttribute('aria-expanded', 'false');
    }

    /* ---------- zmiany w koszyku ---------- */

    /* Strzalki „-" i „+" nie czekaja na sklep: liczba na ekranie zmienia sie
       od razu, a do koszyka idzie JEDNA zbiorcza zmiana po ostatnim kliknieciu.
       Wczesniej kazde klikniecie wysylalo zadanie i przerysowywalo cala sekcje,
       wiec przy wiekszych ilosciach nie dalo sie doklikac z 8 do 1. */
    przesunIlosc(przycisk) {
      const pozycja = przycisk.closest('[data-line-key]');
      const pole = pozycja ? pozycja.querySelector('[data-cart-drawer-quantity-value]') : null;
      if (!pozycja || !pole) return;

      const krok = Number(przycisk.dataset.cartDrawerStep) || 0;
      const teraz = Number(pole.textContent.trim()) || 0;
      const nowa = Math.max(0, teraz + krok);
      if (nowa === teraz) return;

      pole.textContent = String(nowa);
      /* Zejscie do zera to usuniecie pozycji - wtedy nie ma juz czego klikac. */
      if (nowa === 0) pozycja.classList.add('cart-drawer-item--znika');

      this.doWyslania = this.doWyslania || {};
      this.doWyslania[pozycja.dataset.lineKey] = nowa;
      window.clearTimeout(this.zegarIlosci);
      this.zegarIlosci = window.setTimeout(() => this.wyslijIlosci(), 500);
    }

    /* Jedno `/cart/update.js` na wszystkie odlozone zmiany - klucze pozycji
       zmieniaja sie po kazdym przeliczeniu rabatu, wiec seria `change.js`
       na zapamietanych kluczach padlaby na drugim wywolaniu.
       Oddaje obietnice CALEJ wysylki razem z ogonem, wiec kasa moze na nia
       poczekac; wolane w trakcie wysylki oddaje te sama obietnice. */
    wyslijIlosci() {
      if (this.wysylkaIlosci) return this.wysylkaIlosci;
      const zmiany = this.doWyslania;
      if (!zmiany || Object.keys(zmiany).length === 0) return Promise.resolve();
      this.doWyslania = null;
      this.wysylkaIlosci = (async () => {
        try {
          await json('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: zmiany }) });
          await this.odswiez();
        } catch (blad) {
          this.pokazBlad();
          await this.odswiez();
        } finally {
          this.wysylkaIlosci = null;
        }
        /* Klient klikal dalej, kiedy szlo zadanie - domykamy ogon. */
        if (this.doWyslania) await this.wyslijIlosci();
      })();
      return this.wysylkaIlosci;
    }

    async zmienIlosc(przycisk) {
      const pozycja = przycisk.closest('[data-line-key]');
      if (!pozycja) return;
      const ilosc = Number(przycisk.dataset.cartDrawerQuantity);
      if (Number.isNaN(ilosc) || ilosc < 0) return;

      this.zablokuj(true);
      try {
        await json('/cart/change.js', {
          method: 'POST',
          body: JSON.stringify({ id: pozycja.dataset.lineKey, quantity: ilosc }),
        });
        await this.odswiez();
      } catch (blad) {
        this.pokazBlad();
      } finally {
        this.zablokuj(false);
      }
    }

    /* ---------- wzory zestawu z list wyboru ---------- */

    /* Klient zwykle wybiera kilka wzorow pod rzad. Kazdy wybor zmienia
       tylko ekran (miniatura, wyszarzenie wzoru w pozostalych listach),
       a do sklepu idzie JEDNA zmiana zestawu chwile po ostatnim wyborze -
       bez przerysowania szuflady po kazdym kliknieciu. Do tego czasu
       „Dalej" stoi nieaktywne, zeby klient nie poszedl dalej ze starym
       zestawem. */
    zaplanujZestaw(pole) {
      const karta = pole.closest('[data-cart-set]');
      if (!karta) return;
      this.pokazWyborZestawu(karta, pole);
      this.zestawyDoWyslania = this.zestawyDoWyslania || new Set();
      this.zestawyDoWyslania.add(karta.dataset.cartSet);
      /* „Dalej" mowi, na co czeka - przerysowanie szuflady po zapisie
         przywraca zwykly napis. */
      const dalej = this.querySelector('[data-cart-next]');
      if (dalej) {
        dalej.disabled = true;
        if (dalej.dataset.labelUpdating && !dalej.classList.contains('cart-drawer__button--loading')) {
          dalej.classList.add('cart-drawer__button--loading');
          const krecik = document.createElement('span');
          krecik.className = 'cart-drawer__spinner';
          krecik.setAttribute('aria-hidden', 'true');
          dalej.replaceChildren(krecik, document.createTextNode(dalej.dataset.labelUpdating));
        }
      }
      this.odliczZestaw();
    }

    odliczZestaw() {
      window.clearTimeout(this.zegarZestawu);
      this.zegarZestawu = window.setTimeout(() => this.wyslijZestawy(), 1000);
    }

    pokazWyborZestawu(karta, pole) {
      const opcja = pole.options[pole.selectedIndex];
      const chip = pole.closest('.cart-drawer-item__chip');
      const miniatura = opcja && opcja.dataset.thumb;
      if (chip && miniatura) {
        const img = chip.querySelector('img');
        const puste = chip.querySelector('.cart-drawer-item__chip-blank');
        if (img) img.src = miniatura;
        if (puste) puste.style.backgroundImage = `url("${miniatura}")`;
      }
      if (chip) chip.classList.toggle('cart-drawer-item__chip--empty', !pole.value);
      this.odswiezZestaw(karta);
    }

    /* Wzor stojacy w jednym okienku jest wyszarzony w pozostalych, a „+"
       znika, gdy na ekranie stoi juz tyle okienek, ile zestaw moze miec. */
    odswiezZestaw(karta) {
      const widoczne = (lista) => !lista.closest('[hidden]');
      const listy = Array.from(karta.querySelectorAll('[data-cart-set-sample], [data-cart-set-add]')).filter(widoczne);
      listy.forEach((lista) => {
        const zajete = new Set(listy.filter((inna) => inna !== lista && inna.value).map((inna) => inna.value));
        Array.from(lista.options).forEach((o) => {
          if (!o.value || o.value === lista.value) return;
          o.disabled = o.hasAttribute('data-soldout') || zajete.has(o.value);
        });
      });
      const plus = karta.querySelector('[data-cart-set-plus-wrap]');
      const maks = Number(karta.dataset.setMax) || 0;
      const wolneOkienko = karta.querySelector('[data-cart-set-slot][hidden]');
      if (plus) plus.hidden = !wolneOkienko || listy.length >= maks;
    }

    /* „+" odslania kolejne wolne okienko i od razu otwiera jego liste. */
    dodajOkienko(przycisk) {
      const karta = przycisk.closest('[data-cart-set]');
      const okienko = karta && karta.querySelector('[data-cart-set-slot][hidden]');
      if (!okienko) return;
      const plus = karta.querySelector('[data-cart-set-plus-wrap]');
      okienko.hidden = false;
      if (plus) plus.before(okienko);
      this.odswiezZestaw(karta);
      const lista = okienko.querySelector('select');
      lista.focus();
      try { lista.showPicker(); } catch (blad) { /* starsza przegladarka - zostaje fokus */ }
    }

    /* „-" przy wzorze zdejmuje go z zestawu (zapis zbiorczy jak przy
       podmianie); przy pustym okienku tylko je chowa. */
    zdejmijOkienko(przycisk) {
      const chip = przycisk.closest('.cart-drawer-item__chip');
      const karta = przycisk.closest('[data-cart-set]');
      if (!chip || !karta) return;
      const lista = chip.querySelector('select');
      const bylWzor = Boolean(lista && lista.value) || chip.hasAttribute('data-line-key');
      if (chip.hasAttribute('data-cart-set-slot')) {
        if (lista) lista.value = '';
        chip.classList.add('cart-drawer-item__chip--empty');
        const puste = chip.querySelector('.cart-drawer-item__chip-blank');
        if (puste) puste.style.backgroundImage = '';
        chip.hidden = true;
      } else {
        /* Wzor z koszyka: chip znika, a jego lista przestaje sie liczyc. */
        if (lista) lista.value = '';
        chip.hidden = true;
      }
      this.odswiezZestaw(karta);
      if (bylWzor && lista) this.zaplanujZestaw(lista);
    }

    async wyslijZestawy() {
      window.clearTimeout(this.zegarZestawu);
      this.zegarZestawu = null;
      const numery = Array.from(this.zestawyDoWyslania || []);
      this.zestawyDoWyslania = new Set();
      if (!numery.length) return;

      const zadania = numery
        .map((numer) => {
          const karta = Array.from(this.querySelectorAll('[data-cart-set]')).find((k) => k.dataset.cartSet === numer);
          if (!karta) return null;
          const wzory = [];
          karta.querySelectorAll('[data-cart-set-sample], [data-cart-set-add]').forEach((lista) => {
            if (lista.closest('[hidden]')) return;
            const id = Number(lista.value);
            if (!id || wzory.some((w) => w.id === id)) return;
            const opcja = lista.options[lista.selectedIndex];
            wzory.push({ id, nazwa: opcja ? opcja.textContent.trim() : '' });
          });
          const etykieta = String(karta.dataset.slotLabel || '__N__');
          return { numer, wzory, etykieta: (n) => etykieta.replace('__N__', String(n)) };
        })
        .filter(Boolean);

      this.zablokuj(true);
      try {
        for (const zadanie of zadania) await this.zapiszZestaw(zadanie);
        await this.odswiez();
      } catch (blad) {
        await this.odswiez().catch(() => {});
        this.pokazBlad();
      } finally {
        this.zablokuj(false);
      }
    }

    /* Zestaw w koszyku = nosnik (wariant i ilosc = liczba wzorow) plus
       probki. Najpierw DOKLADAMY (nowe probki i - gdy zmienia sie liczba
       wzorow - nowy nosnik), potem zdejmujemy to, czego juz nie ma, po
       swiezych kluczach. Awaria w polowie zostawia probke za pelna cene
       albo dwa nosniki (nadmiarowy sprzata szuflada), nigdy darmowa probke.
       Na koncu czytelne wpisy „Probka nr N" na nosniku dla obslugi. */
    async zapiszZestaw({ numer, wzory, etykieta }) {
      const wZestawie = (p, rola) => p.properties && p.properties._zestaw === numer && p.properties._zestaw_rola === rola;
      const items = (await json('/cart.js')).items || [];
      const nosnik = items.find((p) => wZestawie(p, 'nosnik'));
      const probki = items.filter((p) => wZestawie(p, 'probka'));
      if (!nosnik) throw new Error('zestaw');
      const lista = String(nosnik.properties._zestaw_warianty || '').split(',').filter(Boolean).map(Number);
      const chciane = wzory.slice(0, lista.length);

      /* Wszystkie wzory zdjete - schodzi caly zestaw, jak przy „Usun". */
      if (!chciane.length) {
        const zmiany = {};
        items.filter((p) => wZestawie(p, 'nosnik') || wZestawie(p, 'probka')).forEach((p) => { zmiany[p.key] = 0; });
        await json('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: zmiany }) });
        return;
      }

      const nowe = chciane.filter((w) => !probki.some((p) => p.variant_id === w.id));
      const zbedne = probki.filter((p) => !chciane.some((w) => w.id === p.variant_id));
      if (!nowe.length && !zbedne.length) return;

      const wlasciwosci = {};
      Object.keys(nosnik.properties).forEach((k) => {
        if (k.charAt(0) === '_') wlasciwosci[k] = nosnik.properties[k];
      });
      chciane.forEach((w, i) => { wlasciwosci[etykieta(i + 1)] = w.nazwa; });

      const wariant = lista[chciane.length - 1];
      const innyWariant = wariant !== nosnik.variant_id;
      const doDodania = nowe.map((w) => ({ id: w.id, quantity: 1, properties: { _zestaw: numer, _zestaw_rola: 'probka' } }));
      if (innyWariant) doDodania.unshift({ id: wariant, quantity: chciane.length, properties: wlasciwosci });
      if (doDodania.length) {
        await json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: doDodania }) });
      }

      const poDodaniu = (await json('/cart.js')).items || [];
      /* WSZYSTKIE pasujace linie, nie pierwsza: gdy rabat obejmuje tylko
         czesc sztuk nosnika, Shopify rozbija go na dwie linie z roznymi
         kluczami - zdjecie jednej zostawialo w koszyku sztuke starego
         nosnika (zmierzone: zestaw 2 -> 1 dawal 16,00 zamiast 9,50). */
      const zmiany = {};
      poDodaniu.forEach((p) => {
        if (wZestawie(p, 'probka') && zbedne.some((z) => z.variant_id === p.variant_id)) zmiany[p.key] = 0;
        if (innyWariant && wZestawie(p, 'nosnik') && p.variant_id === nosnik.variant_id) zmiany[p.key] = 0;
      });
      if (Object.keys(zmiany).length) {
        await json('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: zmiany }) });
      }

      if (!innyWariant) {
        const poZmianie = (await json('/cart.js')).items || [];
        const biezacy = poZmianie.find((p) => wZestawie(p, 'nosnik'));
        if (biezacy) {
          await json('/cart/change.js', {
            method: 'POST',
            body: JSON.stringify({ id: biezacy.key, quantity: biezacy.quantity, properties: wlasciwosci }),
          });
        }
      }
    }

    async usunZestaw(karta) {
      if (!karta) return;
      /* Nosnik i wszystkie probki naraz - kazda osobna zmiana przeliczylaby
         rabat i uniewaznila klucze pozostalych pozycji. */
      const zmiany = {};
      zmiany[karta.dataset.lineKey] = 0;
      karta.querySelectorAll('.cart-drawer-item__chip[data-line-key]').forEach((chip) => {
        zmiany[chip.dataset.lineKey] = 0;
      });

      this.zablokuj(true);
      try {
        await json('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: zmiany }) });
        await this.odswiez();
      } catch (blad) {
        this.pokazBlad();
      } finally {
        this.zablokuj(false);
      }
    }

    /* ---------- kod rabatowy ---------- */

    /* Pole `discount` w /cart/update.js ZASTEPUJE cala liste kodow koszyka,
       wiec zawsze wysylamy komplet: obecne kody (takze ukryte kody B2B, ktore
       motyw zaklada po cichu) plus nowy albo bez usuwanego. */
    async zmienKody({ dodaj = '', usun = '' }) {
      const blok = this.querySelector('[data-cart-drawer-discount]');
      const napisy = blok ? { nieDziala: blok.dataset.msgInvalid || '', blad: blok.dataset.msgError || '' } : {};
      this.zablokuj(true);
      let komunikat = '';
      try {
        const koszyk = await json('/cart.js');
        const obecne = (koszyk.discount_codes || []).map((k) => k.code);
        const takiSam = (a, b) => a.toUpperCase() === b.toUpperCase();
        let lista = obecne.filter((k) => !(usun && takiSam(k, usun)));
        if (dodaj && !lista.some((k) => takiSam(k, dodaj))) lista = lista.concat(dodaj);

        const po = await json('/cart/update.js', { method: 'POST', body: JSON.stringify({ discount: lista.join(',') }) });

        if (dodaj) {
          const wpis = (po.discount_codes || []).find((k) => takiSam(k.code, dodaj));
          /* Kod, ktorego sklep nie zna albo ktory nie pasuje do koszyka, nie
             zostaje na liscie - klient dostaje zdanie z nazwa kodu. */
          if (!wpis || wpis.applicable === false) {
            komunikat = (napisy.nieDziala || '').replace('__KOD__', dodaj);
            if (wpis) {
              await json('/cart/update.js', {
                method: 'POST',
                body: JSON.stringify({ discount: lista.filter((k) => !takiSam(k, dodaj)).join(',') }),
              });
            }
          }
        }
        await this.odswiez();
      } catch (blad) {
        komunikat = napisy.blad || '';
      } finally {
        this.zablokuj(false);
      }

      const nowyBlok = this.querySelector('[data-cart-drawer-discount]');
      if (!nowyBlok) return;
      nowyBlok.classList.add('cart-drawer-discount--open');
      nowyBlok.querySelector('.cart-drawer-discount__summary')?.setAttribute('aria-expanded', 'true');
      const miejsce = nowyBlok.querySelector('[data-cart-drawer-discount-message]');
      const pole = nowyBlok.querySelector('[data-cart-drawer-discount-field]');
      if (miejsce) {
        miejsce.textContent = komunikat;
        miejsce.hidden = !komunikat;
      }
      if (komunikat && pole) {
        pole.value = dodaj;
        pole.focus({ preventScroll: true });
      }
    }

    async zapiszUwagi() {
      const pole = this.querySelector('[data-cart-drawer-note-field]');
      if (!pole) return;
      /* Ani blokady, ani odswiezenia sekcji: klient wciaz pisze, a odswiezenie
         podmienilo by pole razem z kursorem. Sama tresc uwag nie zmienia zadnej
         liczby w koszyku, wiec nie ma czego przeliczac. */
      try {
        await json('/cart/update.js', { method: 'POST', body: JSON.stringify({ note: pole.value }) });
      } catch (blad) {
        this.pokazBlad();
      }
    }

    /* ---------- koszt wysylki ---------- */

    wyczyscKod() {
      const pole = this.querySelector('[data-cart-drawer-zip]');
      const wynik = this.querySelector('[data-cart-drawer-rates]');
      const krzyzyk = this.querySelector('[data-cart-drawer-zip-clear]');
      if (pole) {
        pole.value = '';
        pole.focus();
      }
      if (wynik) wynik.textContent = '';
      if (krzyzyk) krzyzyk.hidden = true;
    }

    async policzWysylke() {
      const kalkulator = this.querySelector('[data-cart-drawer-calc]');
      const pole = this.querySelector('[data-cart-drawer-zip]');
      const wynik = this.querySelector('[data-cart-drawer-rates]');
      if (!kalkulator || !pole || !wynik) return;

      const kod = pole.value.trim();
      const napisy = this.napisy();
      wynik.classList.remove('cart-drawer-calc__result--error');
      if (kod === '') {
        wynik.classList.add('cart-drawer-calc__result--error');
        wynik.textContent = napisy.zip_required;
        return;
      }

      wynik.textContent = napisy.checking;
      const parametry = new URLSearchParams({
        'shipping_address[zip]': kod,
        'shipping_address[country]': kalkulator.dataset.country || '',
      });

      try {
        /* Pod prefiksem jezyka strony (/pl/, /de/...): bez niego Shopify pyta
           usluge dostawy w jezyku glownym sklepu i nazwa stawki wychodzi po
           niderlandzku („Bezorging”) na kazdej wersji jezykowej. */
        const korzen = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const odpowiedz = await fetch(`${korzen}cart/shipping_rates.json?${parametry}`, {
          headers: { Accept: 'application/json' },
        });
        const dane = await odpowiedz.json();

        /* Bledny kod pocztowy sklep odrzuca z 422 i wlasnym komunikatem
           per pole ("Podaj prawidlowy kod pocztowy dla Holandii"). Ten
           komunikat jest dla klienta duzo bardziej uzyteczny niz nasz
           ogolnik, wiec pokazujemy go wprost. */
        if (!odpowiedz.ok) {
          const powody = Object.values(dane || {}).flat().filter((x) => typeof x === 'string');
          wynik.classList.add('cart-drawer-calc__result--error');
          wynik.textContent = powody.length > 0 ? powody.join(' ') : napisy.no_rates;
          return;
        }

        const stawki = (dane.shipping_rates || []);
        if (stawki.length === 0) {
          wynik.classList.add('cart-drawer-calc__result--error');
          wynik.textContent = napisy.no_rates;
          return;
        }
        wynik.textContent = '';
        /* Ten sam kod wpisuje sie potem sam w kroku 2 i jest tam sprawdzany
           od nowa - wczesniej klient musial go podac drugi raz (audyt na
           slepo 27.10.2026). Klucz wspolny z oknem dostawy. */
        try { sessionStorage.setItem('dizz_dostawa_kod', kod); } catch (e) { /* tryb prywatny */ }
        const naglowek = document.createElement('p');
        naglowek.textContent = napisy.rates_for.replace('{{ zip }}', kod);
        wynik.appendChild(naglowek);
        stawki.forEach((stawka) => {
          const wiersz = document.createElement('p');
          wiersz.textContent = `${stawka.name}: ${this.kwota(stawka.price)}`;
          wynik.appendChild(wiersz);
        });
      } catch (blad) {
        wynik.classList.add('cart-drawer-calc__result--error');
        wynik.textContent = napisy.error;
      }
    }

    kwota(wartosc) {
      const liczba = Number(wartosc);
      if (Number.isNaN(liczba)) return String(wartosc);
      /* Format kwoty sklepu, ten sam co w oknie dostawy - Intl po angielsku
         dawal "€49.00" obok "€69,00" (audyt na slepo 27.10.2026). */
      const format = this.dataset.moneyFormat;
      if (format) {
        const [calosc, ulamek] = liczba.toFixed(2).split('.');
        const zKropka = calosc.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const zPrzecinkiem = calosc.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const zSpacja = calosc.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        const warianty = {
          amount: `${zPrzecinkiem}.${ulamek}`,
          amount_no_decimals: zPrzecinkiem,
          amount_with_comma_separator: `${zKropka},${ulamek}`,
          amount_no_decimals_with_comma_separator: zKropka,
          amount_with_space_separator: `${zSpacja},${ulamek}`,
          amount_no_decimals_with_space_separator: zSpacja,
        };
        const wynik = format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, klucz) => warianty[klucz] ?? '');
        if (/\d/.test(wynik)) return wynik.replace(/<[^>]*>/g, '');
      }
      try {
        return new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
        }).format(liczba);
      } catch (blad) {
        return `${liczba.toFixed(2)} ${this.dataset.currency || ''}`.trim();
      }
    }

    /* Przeciagniecie uchwytu w dol zamyka szuflade - ten sam gest co w szufladzie
       nawigacji i w kazdym arkuszu wysuwanym od dolu. Ponizej progu panel wraca
       na miejsce. Uchwyt jest tylko na telefonie, wiec na desktopie gestu nie ma. */
    podepnijPrzeciaganieUchwytu() {
      // Panel wyszukujemy przy KAZDYM gescie, nie raz na starcie: odswiezenie
      // koszyka podmienia wnetrze szuflady i zapamietany wezel bylby juz
      // odpiety od strony (panel nie jechalby za palcem).
      const panelTeraz = () => this.querySelector('.cart-drawer__panel');

      const PROG_ZAMKNIECIA = 80;
      let startY = 0;
      let deltaY = 0;
      let przeciaga = false;

      const naRuch = (zdarzenie) => {
        if (!przeciaga) return;
        const panel = panelTeraz();
        if (!panel) return;
        deltaY = Math.max(0, zdarzenie.clientY - startY);
        panel.style.transform = `translateY(${deltaY}px)`;
      };

      const naKoniec = () => {
        if (!przeciaga) return;
        przeciaga = false;
        const panel = panelTeraz();
        if (panel) {
          panel.classList.remove('cart-drawer__panel--przeciagane');
          panel.style.transform = '';
        }
        if (deltaY > PROG_ZAMKNIECIA) this.zamknij();
        deltaY = 0;
      };

      /* Uchwyt jest wymieniany przy kazdym odswiezeniu sekcji, wiec sluchamy
         na szufladzie, a nie na samym uchwycie. */
      this.addEventListener('pointerdown', (zdarzenie) => {
        if (!zdarzenie.target.closest('.cart-drawer__handle')) return;
        const panel = panelTeraz();
        if (!panel) return;
        przeciaga = true;
        startY = zdarzenie.clientY;
        deltaY = 0;
        panel.classList.add('cart-drawer__panel--przeciagane');
        this.setPointerCapture(zdarzenie.pointerId);
      });
      this.addEventListener('pointermove', naRuch);
      this.addEventListener('pointerup', naKoniec);
      this.addEventListener('pointercancel', naKoniec);
    }

    /* ---------- odswiezanie ---------- */

    async odswiez() {
      /* Wybory w listach zestawu czekajace na wyslanie ida PRZED
         przerysowaniem - inaczej Liquid oddalby stary zestaw i skasowal to,
         co klient wlasnie wybral. wyslijZestawy sam odswieza szuflade. */
      if (this.zestawyDoWyslania && this.zestawyDoWyslania.size) {
        await this.wyslijZestawy();
        return;
      }
      /* Odlozone zmiany ilosci musza pojsc przed przerysowaniem, inaczej
         Liquid oddalby stara liczbe i nadpisal to, co klient wlasnie wyklikal,
         a kolejne klikniecie liczyloby od niej (zmierzone 29 pazdziernika 2026:
         1 -> 3 na ekranie, po przerysowaniu 1 i w koszyku 1). wyslijIlosci sam
         przerysowuje szuflade; gdy wysylka juz trwa, zrobi to jej ogon. */
      window.clearTimeout(this.zegarIlosci);
      if (this.doWyslania && Object.keys(this.doWyslania).length) {
        if (!this.wysylkaIlosci) await this.wyslijIlosci();
        return;
      }
      const otwarteHarmonijki = {
        wysylka: !!this.querySelector('.cart-drawer-calc--open'),
        uwagi: !!this.querySelector('.cart-drawer-note--open'),
        kod: !!this.querySelector('.cart-drawer-discount--open'),
      };

      const odpowiedz = await fetch(`${window.location.pathname}?sections=${SEKCJA}`);
      const dane = await odpowiedz.json();
      const swieze = new DOMParser().parseFromString(dane[SEKCJA], 'text/html');
      const nowy = swieze.querySelector('cart-drawer');
      if (!nowy) return;

      const bylOtwarty = this.classList.contains('cart-drawer--open');
      /* Okno dostawy jest wypozyczone z layoutu - gdyby zostalo w srodku,
         podmiana wnetrza skasowalaby je razem z wpisanym kodem pocztowym
         i werdyktem. Wraca do gniazda zaraz po przerysowaniu. */
      if (window.dizzDostawa && window.dizzDostawa.zKoszyka) window.dizzDostawa.zKoszyka();
      this.innerHTML = nowy.innerHTML;
      Array.from(nowy.attributes).forEach((atrybut) => {
        if (atrybut.name === 'hidden' || atrybut.name === 'class') return;
        this.setAttribute(atrybut.name, atrybut.value);
      });
      if (bylOtwarty) this.classList.add('cart-drawer--open');

      if (otwarteHarmonijki.wysylka) {
        const blok = this.querySelector('[data-cart-drawer-calc]');
        if (blok) {
          blok.classList.add('cart-drawer-calc--open');
          blok.querySelector('.cart-drawer-calc__summary')?.setAttribute('aria-expanded', 'true');
        }
      }
      if (otwarteHarmonijki.uwagi) {
        const blok = this.querySelector('[data-cart-drawer-note]');
        if (blok) {
          blok.classList.add('cart-drawer-note--open');
          blok.querySelector('.cart-drawer-note__summary')?.setAttribute('aria-expanded', 'true');
        }
      }

      if (otwarteHarmonijki.kod) {
        const blok = this.querySelector('[data-cart-drawer-discount]');
        if (blok) {
          blok.classList.add('cart-drawer-discount--open');
          blok.querySelector('.cart-drawer-discount__summary')?.setAttribute('aria-expanded', 'true');
        }
      }

      if (this.krok === 2 && !this.wpiszDostawe()) this.krok = 1;
      this.zastosujKrok();
      if (this.krok === 2) this.sprawdzUmowiony();
      /* Koszyk sie zmienil - np. konfigurator zestawu odswieza wtedy
         plakietki „W koszyku" na kafelkach probek. */
      document.dispatchEvent(new CustomEvent('koszyk:zmiana'));

      this.odswiezLicznik();
    }

    odswiezLicznik() {
      const licznik = this.dataset.cartCountValue;
      if (licznik === undefined) return;
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = licznik;
      });
    }

    /* ---------- drobiazgi ---------- */

    zablokuj(stan) {
      this.classList.toggle('cart-drawer--busy', stan);
      this.querySelectorAll('button, select[data-cart-set-sample], select[data-cart-set-add]').forEach((przycisk) => {
        if (stan) {
          if (!przycisk.disabled) przycisk.dataset.wylaczonyTymczasowo = '1';
          przycisk.disabled = true;
        } else if (przycisk.dataset.wylaczonyTymczasowo) {
          delete przycisk.dataset.wylaczonyTymczasowo;
          przycisk.disabled = false;
        }
      });
    }

    napisy() {
      const zrodlo = this.querySelector('[data-cart-drawer-copy]');
      if (!zrodlo) return {};
      try {
        return JSON.parse(zrodlo.textContent);
      } catch (blad) {
        return {};
      }
    }

    pokazBlad() {
      const napisy = this.napisy();
      const wynik = this.querySelector('[data-cart-drawer-rates]');
      if (wynik) {
        wynik.classList.add('cart-drawer-calc__result--error');
        wynik.textContent = napisy.error || '';
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }
})();
